export default __webpack_public_path__ + "static/media/solved.41e2448f.png";